import { GrowModal } from "@sinecycle/growcomponents";
import { Modal } from "antd";
const { confirm } = Modal;
function AntModal(props: React.ComponentProps<typeof GrowModal>) {
  return <GrowModal {...props} />;
}

export const AntConfirm = confirm;
export { AntConfirm as ConFirm, AntModal as Modal };
